// extracted by mini-css-extract-plugin
export default {"imageBoxImage":"ImageBox_imageBoxImage__X5war","imageBoxContainer":"ImageBox_imageBoxContainer__lFyn6"};